// extracted by mini-css-extract-plugin
export default {"BoutonEnTete":"EnTete_BoutonEnTete__g1zM+"};